import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { hideAuthToast } from '../../features/uiSlice';
import styles from '../../css/toasts/AuthToast.module.css';

const AuthToast = () => {
  const dispatch = useDispatch();
  const { visible, message } = useSelector((s) => s.ui.authToast);
  const [hiding, setHiding] = useState(false);
  const timerRef = useRef(null);

  const dismiss = () => {
    setHiding(true);
    setTimeout(() => {
      setHiding(false);
      dispatch(hideAuthToast());
    }, 250);
  };

  useEffect(() => {
    if (!visible) return;
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(dismiss, 4000);
    return () => clearTimeout(timerRef.current);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className={`${styles.toast} ${hiding ? styles.hiding : ''}`}>
      <p className={styles.message}>{message}</p>
      <div className={styles.actions}>
        <Link to="/auth/login" className={styles.btn} onClick={dismiss}>
          Войти
        </Link>
        <button className={styles.close} onClick={dismiss} aria-label="Закрыть">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default AuthToast;
